import {
	type Block,
	type TextAttributes,
	DEFAULT_TEXT_ATTRIBUTES,
	blockTypeToParentTagMap,
} from '$lib/types/AICopywriter/types';

const generateAttributes = (attributes: TextAttributes) => {
	return Object.entries(attributes)
		.map(([key, value]) => `${key}="${value}"`)
		.join(' ');
};

const generateListItemsHTML = (items: string[], attributes: string) => {
	const listItems = items.map((item) => `<li><p ${attributes}>${item}</p></li>`);
	return listItems.join('');
};

export const generatePostBlockHTML = (block: Block) => {
	// TODO: Remove this check once we handle these block types in https://alidacxm.atlassian.net/browse/HUBS-1935
	if (block.type === 'context' || block.type === 'blockquote' || block.type === 'codeBlock') {
		return '';
	}

	const parentTag = blockTypeToParentTagMap[block.type];
	const attributes = generateAttributes(DEFAULT_TEXT_ATTRIBUTES);

	switch (block.type) {
		case 'orderedList':
		case 'unorderedList': {
			const listItemsHTML = generateListItemsHTML(block.content, attributes);
			return `<${parentTag}>${listItemsHTML}</${parentTag}>`;
		}
		default: {
			return `<${parentTag} ${attributes}>${block.content}</${parentTag}>`;
		}
	}
};
